import { useTranslation } from 'react-i18next';
import InputFormBorder from '../../Common/InputFormBorder/InputFormBorder';
import InputPhone from '../../Common/InputPhone/InputPhone';

const ReservationCheckCustomerInfo = ({ handleChange, values, errors, countryCode }) => {
  const { t } = useTranslation();

  const onHandleChangePhone = (e) => {
    handleChange({ target: { name: 'phone', value: e }, persist: () => {} });
  };

  return (
    <div>
      <div className='position-relative d-flex'>
        <div style={{ flex: '1', marginRight: '10px' }}>
          <InputFormBorder
            color='#757575'
            name='customerName'
            type='text'
            error={errors.customerName}
            onChange={handleChange}
            value={values.customerName}
            placeholder={t('profile.firstName')}
            customClass='border-none p-0'
          />
        </div>
        <div style={{ flex: '1' }}>
          <InputFormBorder
            color='#fff'
            name='customerLastname'
            error={errors.customerLastname}
            type='text'
            onChange={handleChange}
            value={values.customerLastname}
            placeholder={t('profile.lastName')}
            customClass='border-none p-0'
          />
        </div>
      </div>

      <InputPhone
        placeholder={t('mobile')}
        onHandleChange={onHandleChangePhone}
        error={errors.phone}
        t={t}
        countryCode={countryCode}
      />

      <div>
        <InputFormBorder
          color='#757575'
          name='email'
          type='email'
          icon={'mail'}
          onChange={handleChange}
          value={values.email}
          error={errors.email}
          placeholder={'E-mail'}
          label={t('reservationEmail')}
          forceLowecase={true}
          border={'none'}
        />
      </div>
    </div>
  );
};

export default ReservationCheckCustomerInfo;
